import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { useMultiStyleConfig } from '~/utils/styleHelpers'

const BlockedNumberModalStyleParts = [
  'footer',
  'body',
  'inputContainer',
] as const

const helpers = createMultiStyleConfigHelpers(BlockedNumberModalStyleParts)

export const BlockedNumberModalStyles = helpers.defineMultiStyleConfig({
  baseStyle: {
    inputContainer: {
      width: '24rem',
      mb: '1rem',
      alignItems: 'center',
    },
    body: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: '1rem',
    },
    footer: {
      gap: '0.8rem',
      alignItems: 'flex-end',
    },
  },
})

export const useBlockedNumberModalStyles = (props?: StyleThemingProps) => {
  return useMultiStyleConfig(BlockedNumberModalStyles, props) as MultiStyleType<
    typeof BlockedNumberModalStyleParts
  >
}
